import FilledFolderIcon from "@assets/icons/filled-folder.svg";

import { IFolderTag } from "@interfaces/tag.interface";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IFolderTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionFolder = ({ item, ...rest }: Props) => {
  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <FilledFolderIcon
        width={20}
        height={20}
        className="flex-shrink-0 text-gray-600 dark:text-gray-300"
      />
      <TagLabel>{item.name}</TagLabel>
    </div>
  );
};
